import React from 'react';
import {Image, Row, Col, Container} from 'react-bootstrap';
import translate from '../../../../translate';
import AppIconWbd from '../../../Landing2.0/assets/icons/store-wbd-icon.svg';
import AppCelular from '../../../Landing2.0/assets/images/app-celular.svg';
import AppStore from '../../../Landing2.0/assets/icons/app-store-w.svg';
import GoogleStore from '../../../Landing2.0/assets/icons/google-store-w.svg';
import './downloadApp.css'

const DownloadApp = ({...props}) => {
  const {lan} = props;
  const transl = translate[lan].LandingCard.section3;

  return(
    <div className='wrapper-white-card' id='download-app-card'>
      <Container fluid>
        <div className='orange-wrapper-card'>
          <Row className='direction-mobile'>
            <Col xxl={5} xl={5} lg={6} md={5} className='align-cel-web-card'>
              <Image src={AppCelular} className='responsive-cel-web-card'/>
            </Col>
            <Col xxl={6} xl={6} lg={5} md={6} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
              <div style={{textAlign: 'center'}}>
                <span className='download-title-card'>
                  {transl.title}
                </span>
              </div>
              <div style={{marginTop: 20, textAlign: 'center'}}>
                <span className='download-subtitle-card'>
                  {transl.subtitle}
                </span>
              </div>
              <div className='wrapper-stores-btns-mobile-card'>
                <a href="https://apps.apple.com/mx/app/wirebit-digital/id1563970813" target='_blank' style={{margin: '0px 20px'}}>
                  <Image src={AppStore} className='responsive-separate-download-app'/>
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.wirebitdigitalapp" target='_blank'>
                  <Image src={GoogleStore} className='responsive-separate-download-app'/>
                </a>
              </div>
            </Col>
            <Col xxl={1} xl={1} lg={1} md={1} className='align-icon-card'>
              <Image src={AppIconWbd} className='download-app-wbd-logo-card'/>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  )
}
export default DownloadApp;